import type { FaireProductEntity } from "../../entity_types/product";

export const p_ja4env94bz: FaireProductEntity = {
  token: "p_ja4env94bz",
  type: "product",
  name: "Girls Crochet Set | Sunshine",
  brandToken: "b_96lk8mhfjw",
  brandName: "Andy & Evan",
  imageUrl:
    "https://cdn.faire.com/fastly/bc420e1c539d26163dd33d4625d23de3056593b7a79474f67eeaf993b1c56b3e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea7cd07bc220e9a84dea859f69e4353bc222dc74d35ee73bb4d3295463437199.jpeg",
    "https://cdn.faire.com/fastly/1a0d48adaff8644a165328f67dde18217db418e99a2ea81571de3e6deef58ac5.jpeg",
    "https://cdn.faire.com/fastly/1ac819d038f4380346c96ff10636219e8473ad2e1e12b59e754c3614f7a7589a.jpeg",
    "https://cdn.faire.com/fastly/636bd092a00d641ae3f73b9082a8e2ba49e18ff032f1ede1c8af35632a1615b8.jpeg",
    "https://cdn.faire.com/fastly/8d41ae3eb3d966cf045ef6e7373b31ec11a5ab7bb97a8782c398b38ffe256abc.jpeg",
    "https://cdn.faire.com/fastly/dc3e3acf3ae1c7ed1b5915a4f7f36c624acb6508a49d13a24b27966295c14ea4.jpeg",
    "https://cdn.faire.com/fastly/30bde82683c2c8807b45d4a30bdac1030bf5db90b8228023c95f60b5fe583935.jpeg",
    "https://cdn.faire.com/fastly/5bfad2add18c344c4d802d7d31c1b8bb7f2bf0cb3b626d4900712740c1366b57.jpeg",
    "https://cdn.faire.com/fastly/1c7e9889220382c790466bdcd52a60e98941dff8899744e5a40788fb814535dc.jpeg",
  ],
  priceDollars: 22.4,
  description:
    "Infuse her summer wardrobe with a burst of artisanal charm and vibrant color! This stunning crochet set features a lively palette of coral, yellow, blue, and pink, meticulously woven into a classic pattern that captures the essence of carefree sunny days. Perfect for beach vacations, garden parties, or stylish weekend outings, this lightweight duo offers a trendy, bohemian-inspired look that is as comfortable as it is eye-catching.\n\n * Bright Multi Colors: Cheerful coral, yellow, blue, pink, and white that pop. \n * Crochet Fabric: Soft, breathable, and gentle on toddler skin. \n * Two-Piece Set: Mix-and-match for endless styling fun. \n * Lightweight & Comfortable: Perfect for all-day play. \n * Everyday-to-Special Occasion: Cute for parties, durable for playdates. ",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:53.671Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
